import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@mui/styles";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const useStyles = makeStyles((theme) => ({
  accordionContent: {
    display: "flex",
    gap: "1rem",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #D3D3D3",
    padding: "0.2rem 1rem",
  },
  accordionSummary: {
    flexDirection: "row",
    padding:"0 9px 0",
    lineHeight:"1"
    //   paddingLeft: '0px',
    //   padding:"0" ,
  },
  headingContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "1rem",
    width: "100%",
  },
  processedText: {
    marginLeft: "auto",
  },
  expandIcon: {
    marginRight: "auto",
    fontSize: "13px",
  },
}));
const OptixDataFormatted = ({ data, auditID, category, store_type, type,time,count}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const formattedDate = new Date(time);

    // Get the time components (hours, minutes, and seconds)
    const hours = formattedDate.getUTCHours();
    const minutes = formattedDate.getUTCMinutes();
    const seconds = formattedDate.getUTCSeconds();

    // Format the time as HH:MM:SS
    const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  //console.log(data);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };
  return (
    <div style={{ width: "96%", margin: "auto", marginTop: "0rem" }}>
      <Accordion style={{ backgroundColor: "#EAEAEA", borderRadius: "0" }}>
        <AccordionSummary className={classes.accordionSummary}>
          <ExpandMoreIcon className={classes.expandIcon} onClick={toggleAccordion}/>
          <div className={classes.headingContainer}>
            <Typography style={{ fontSize: "11px" ,fontWeight:"550", wordBreak:"break-all"}}>
              {auditID}/{formattedTime}/{category}/{store_type}/{type}
              {/* 009EJ6W1892PPYV/{time}/{category}/{store_type}/{type} */}
            </Typography>
            {/* add time and audit id of real time */}
            <Typography variant="caption" className={classes.processedText}>
                <div style={{display:"flex",alignItems:"center",flexDirection:"column" ,fontSize:"11px"}}><span>Processed</span>
                <span>{count}</span></div>
              {/* <span style={{ fontSize: "11px",margin:"auto"}}> Processed 1</span> */}
            </Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          {data.length === 0 && <div style={{fontSize:"11px"}}>No data</div>}
          {data.length !== 0 && data.map((auditItem, index) => (
            <div className={classes.accordionContent} key={index}>
              <Typography variant="caption" style={{color:"#5A5A5A",fontSize:"12px"}}>{auditItem.question}</Typography>
              <div style={{ marginLeft: "auto" }}>
                <Typography variant="caption">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.2rem",
                    }}
                  >
                    {auditItem.answer==="Yes"?(<span style={{border:"2px solid green", padding:"0px 3px", height:"fit-content", width:"fit-content", fontSize:"12px"}}>{auditItem.answer}</span>):auditItem.answer === "No"?(<span style={{border:"2px solid red", padding:"0px 3px", height:"fit-content", width:"fit-content",fontSize:"12px"}}>{auditItem.answer}</span>):(<span style={{padding:"0px 3px", height:"fit-content", width:"fit-content",fontSize:"12px"}}>{auditItem.answer}</span>)}
                    {auditItem.answer === "Yes" ? (
                      <CheckCircleIcon
                        color="success"
                        style={{ fontSize: "16px" }}
                      />
                    ) : auditItem.answer === "No" ? (
                      <CancelIcon color="error" style={{ fontSize: "16px" }} />
                    ) : (
                      ""
                    )}
                  </div>
                </Typography>
              </div>
            </div>
          ))}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default OptixDataFormatted;
